import { useEffect } from "react";

export const useRegisterRefetchPageData = (refetchFunction: EventListener) => {
  useEffect(() => {
    addEventListener("refetchPageData", refetchFunction);
    return () => removeEventListener("refetchPageData", refetchFunction);
  }, []);
};
